<template>
  <div v-if="loader" style="height: 200px; line-height: 250px;">
    <v-progress-circular indeterminate :size="50"></v-progress-circular>
  </div>
  <div v-else class="ma-8">
    <!-- Order Status Title -->
    <div class="title-cadre mb-10">
      <div class="title">
        {{ $t('orders.validationTab.ordersStatus') }}
      </div>
    </div>

    <!-- Status Timeline -->
    <div class="timelineStatus my-2">
      <div class="main-timeline">
        <!-- Pending Status -->
        <div class="status-container">
          <StatusButton disableIcon :title="statusTitle(STATUS.PENDING)"
            :color="Status == 0 ? '#FF8934' : Status > 0 ? '#00CBA0' : '#C5CDD4'">
            <template v-slot:icon></template>
          </StatusButton>

          <!-- Rejection branch -->
          <div class="rejection-branch" v-if="Status === STATUS.REJECTED">
            <div class="vertical-line"></div>
            <StatusButton class="rejected-status" disableIcon :title="statusTitle(STATUS.REJECTED)"
              :color="getTimelineStatusColor(STATUS.REJECTED)">
              <template v-slot:icon></template>
            </StatusButton>
          </div>

          <div class="rejection-branch" v-if="Status === STATUS.CANCELED">
            <div class="vertical-line"></div>
            <StatusButton class="rejected-status" disableIcon :title="statusTitle(STATUS.CANCELED)"
              :color="getTimelineStatusColor(STATUS.CANCELED)">
              <template v-slot:icon></template>
            </StatusButton>
          </div>
        </div>

        <!-- Horizontal line to Confirmed -->
        <v-sheet elevation="0" :height="5" :width="120" :color="getTimelineStatusColor(STATUS.CONFIRMED)"
          :class="{ 'dimmed': Status === STATUS.REJECTED || Status === STATUS.CANCELED }"></v-sheet>

        <!-- Confirmed Status -->
        <StatusButton disableIcon :title="statusTitle(STATUS.CONFIRMED)"
          :color="getTimelineStatusColor(STATUS.CONFIRMED)">
          <template v-slot:icon></template>
        </StatusButton>
        <v-sheet elevation="0" :height="5" :width="120" :color="getTimelineStatusColor(STATUS.IN_PROGRESS)"
          :class="{ 'dimmed': Status === STATUS.REJECTED || Status === STATUS.CANCELED }"></v-sheet>

        <!-- In Progress Status -->
        <StatusButton disableIcon :title="statusTitle(STATUS.IN_PROGRESS)"
          :color="getTimelineStatusColor(STATUS.IN_PROGRESS)">
          <template v-slot:icon></template>
        </StatusButton>
        <v-sheet elevation="0" :height="5" :width="120" :color="getTimelineStatusColor(STATUS.IN_DELIVERY)"
          :class="{ 'dimmed': Status === STATUS.REJECTED || Status === STATUS.CANCELED }"></v-sheet>

        <!-- In Delivery Status -->
        <StatusButton disableIcon :title="statusTitle(STATUS.IN_DELIVERY)"
          :color="getTimelineStatusColor(STATUS.IN_DELIVERY)">
          <template v-slot:icon></template>
        </StatusButton>
        <v-sheet elevation="0" :height="5" :width="120" :color="getTimelineStatusColor(STATUS.DELIVERED)"
          :class="{ 'dimmed': Status === STATUS.REJECTED || Status === STATUS.CANCELED }"></v-sheet>

        <!-- Delivered Status -->
        <StatusButton disableIcon :title="statusTitle(STATUS.DELIVERED)"
          :color="getTimelineStatusColor(STATUS.DELIVERED)">
          <template v-slot:icon></template>
        </StatusButton>
      </div>
    </div>

    <!-- Validation Buttons (Visible only when status is PENDING) -->
    <div v-if="Status === STATUS.PENDING" class="my-8 row justify-content-center">
      <div class="col-6 justify-content-center">
        <div class="row justify-content-center">
          <div class="col-auto">
            <genericBtnComponent backgroundColor="#114EF7" @click="dialogValidation = true"
              :Title="$t('orders.validationTab.toValidate')" width="200">
              <!-- Button Icon -->
            </genericBtnComponent>
          </div>
          <div class="col-auto">
            <genericBtnComponent backgroundColor="#F25C5C" @click="dialogCommentRefuse = true"
              :Title="$t('orders.validationTab.toReject')" width="200">
              <!-- Button Icon -->
            </genericBtnComponent>
          </div>
        </div>
      </div>
    </div>

    <!-- Validation History Table -->
    <div v-if="TraceValidationList">
      <div class="title-cadre mt-10 mb-4">
        <div class="title">
          {{ $t('orders.validationTab.validationHistory') }}
        </div>
      </div>
      <v-table fixed-header height="200px">
        <thead>
          <tr>
            <th class="text-center">
              {{ $t('orders.validationTab.StatusChangedDate') }}
            </th>
            <th class="text-center">
              {{ $t('orders.validationTab.ChangedBy') }}
            </th>
            <th class="text-center">
              {{ $t('orders.validationTab.lastStatus') }}
            </th>
            <th class="text-center">
              {{ $t('orders.validationTab.currentstatus') }}
            </th>
            <th class="text-center">
              {{ $t('orders.validationTab.commentaire') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in TraceValidationList" :key="item.validationDate">
            <td>{{ formattedDateTime(item.validationDate) }}</td>
            <td>
              <v-list-item-title v-text="item.validatedBy.fullName"></v-list-item-title>
              <v-list-item-subtitle v-text="item.validatedBy.email"></v-list-item-subtitle>
            </td>
            <td>
              <StatusButton disableIcon :title="statusTitle(getStatusFromString(item.lastStatus))"
                :color="getStatusColor(getStatusFromString(item.lastStatus))" style="zoom: 0.9;">
              </StatusButton>
            </td>
            <td>
              <StatusButton disableIcon :title="statusTitle(getStatusFromString(item.status))"
                :color="getStatusColor(getStatusFromString(item.status))" style="zoom: 0.9;">
              </StatusButton>
            </td>
            <td>
              {{ item.comment }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>

  <!-- Rejection Dialog -->
  <v-dialog v-model="dialogCommentRefuse" v-if="dialogCommentRefuse">
    <v-card width="max-content" height="max-content" class="px-8 py-4">
      <div class="row justify-content-center">
        <v-card-title class="text-left">
          {{ $t('orders.validationTab.commentaireRefuser') }} : <span class="red">*</span>
        </v-card-title>
      </div>
      <div class="row justify-content-center">
        <v-textarea id="Comment" v-model="commentaireRefuse" variant="outlined" counter
          :label="$t('orders.validationTab.commentaireLabel')" single-line auto-grow hide-details
          maxlength="500"></v-textarea>
        <span class="warningHint" id="WarningMsgComment">{{ msg.refuseComment }}</span>
      </div>
      <!-- Contact Customer Option -->
      <div class="row justify-content-center my-2">
        <v-checkbox v-model="contactCustomer" :label="$t('orders.validationTab.contactCustomer')"></v-checkbox>
      </div>
      <div class="row justify-content-center">
        <card-actions :yes="RefuseOrder" v-model:no="dialogCommentRefuse" width="200px"
          :yesTitle="$t('orders.validationTab.send')" :YesColor="'#F25C5C'" />
      </div>
    </v-card>
  </v-dialog>

  <!-- Validation Confirmation Dialog -->
  <dialogDelete :loader="buttonLoader" DialogType="Validation" :title="$t('orders.order')" :yes="ValideOrder"
    v-model="dialogValidation" />
</template>

<script>
import {
  getOrderById,
  getOrderValidationTrace,
  updateOrderStatus,
} from '@/api/index';
import StatusButton from '@/genericComponent/StatusButton.vue';
import CardActions from '@/genericComponent/cardActions.vue';
import DialogDelete from '@/genericComponent/dialogDelete.vue';
import genericBtnComponent from '@/genericComponent/genericBtnComponent.vue';

export default {
  components: {
    StatusButton,
    genericBtnComponent,
    CardActions,
    DialogDelete,
  },
  data() {
    return {
      loader: true,
      Order: null,
      idOrder: null,
      Status: null,
      // Updated STATUS enum
      STATUS: {
        PENDING: 0,
        CONFIRMED: 1,
        IN_PROGRESS: 2,
        IN_DELIVERY: 3,
        DELIVERED: 4,
        REJECTED: 5,
        CANCELED: 6
      },
      validationStatus: 1, // CONFIRMED
      refuseStatus: 5, // REJECTED
      commentaireRefuse: null,
      dialogValidation: false,
      dialogCommentRefuse: false,
      msg: [],
      buttonLoader: false,
      TraceValidationList: null,
      contactCustomer: false, // For the contact customer option
    };
  },
  created() {
    this.idOrder = this.$route.params.id;
    this.getOrderById(this.idOrder);
  },
  methods: {
    getOrderById(idOrder) {
      this.loader = true;
      getOrderById(idOrder)
        .then(({ data }) => {
          this.Order = data;
          this.Status = data.status;
          this.getOrderValidationTrace(idOrder);
        })
        .catch((error) => {
          console.error('Error fetching order:', error);
          this.loader = false;
        });
    },
    getOrderValidationTrace(orderId) {
      getOrderValidationTrace(orderId)
        .then(({ data }) => {
          this.TraceValidationList = data;
        })
        .catch((error) => {
          console.error('Error fetching validation trace:', error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    ChangeStatusOfOrderById(idOrder, newStatus, comment) {
      return updateOrderStatus(idOrder, newStatus, comment)
        .then(() => {
          this.Status = newStatus; // Update the current status
          this.Order.status = newStatus; // Ensure the order object reflects the new status
          this.getOrderValidationTrace(idOrder); // Refresh the validation history
        })
        .catch((error) => {
          console.error('Error updating order status:', error);
        });
    },
    ValideOrder() {
      this.buttonLoader = true;
      this.ChangeStatusOfOrderById(this.idOrder, this.validationStatus, '').then(() => {
      }).finally(() => { this.buttonLoader = false; this.dialogValidation = false; });

    },
    RefuseOrder() {
      if (!this.commentaireRefuse) {
        this.msg.refuseComment = this.$t('orders.validationTab.requiredCommentRefusal');
      } else {
        let comment = this.commentaireRefuse;
        if (this.contactCustomer) {
          comment += ' - ' + this.$t('orders.validationTab.contactCustomerSelected');
        }
        this.ChangeStatusOfOrderById(this.idOrder, this.refuseStatus, comment).then(() => {
          this.commentaireRefuse = '';
          this.msg.refuseComment = '';
          this.dialogCommentRefuse = false;
        });
      }
    },
    statusTitle(option) {
      switch (option) {
        case this.STATUS.PENDING:
          return this.$t('orders.statusList.pending');
        case this.STATUS.CONFIRMED:
          return this.$t('orders.statusList.confirmed');
        case this.STATUS.IN_PROGRESS:
          return this.$t('orders.statusList.inProgress');
        case this.STATUS.IN_DELIVERY:
          return this.$t('orders.statusList.inDelivery');
        case this.STATUS.DELIVERED:
          return this.$t('orders.statusList.delivered');
        case this.STATUS.REJECTED:
          return this.$t('orders.statusList.rejected');
        case this.STATUS.CANCELED:
          return this.$t('orders.statusList.canceled');
      }
    },
    getStatusColor(status) {
      switch (status) {
        case this.STATUS.PENDING:
          return '#C5CDD4'; // Gray
        case this.STATUS.CONFIRMED:
          return '#114EF7'; // Blue
        case this.STATUS.IN_PROGRESS:
          return '#FF8934'; // Orange
        case this.STATUS.IN_DELIVERY:
          return '#3BBAFF'; // Light Blue
        case this.STATUS.DELIVERED:
          return '#00CBA0'; // Green
        case this.STATUS.REJECTED:
          return '#F25C5C'; // Red
        case this.STATUS.CANCELED:
          return '#F25C5C'; // Red
      }
    },
    getTimelineStatusColor(statusStep) {
      if (this.Status === this.STATUS.REJECTED || this.Status === this.STATUS.CANCELED) {
        // Only highlight Pending and Rejected states when rejected
        if (statusStep === this.STATUS.PENDING || statusStep === this.STATUS.REJECTED || statusStep === this.STATUS.CANCELED) {
          return this.getStatusColor(statusStep);
        }
        return '#E5E7EB'; // Dim color for other states
      }

      // Color for completed steps
      if (statusStep < this.Status) {
        return '#00CBA0'; // Green for completed steps
      }

      // Current status
      if (statusStep === this.Status) {
        return this.getStatusColor(statusStep); // Keep original color
      }

      // Future steps
      return '#E5E7EB'; // Gray for future steps
    },
    formattedDateTime(dateString) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const utcDateString = dateString.replace(' ', 'T') + 'Z';
      const utcDate = new Date(utcDateString);

      const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: userTimeZone }));

      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, '0');
      const day = String(localDate.getDate()).padStart(2, '0');
      const hours = String(localDate.getHours()).padStart(2, '0');
      const minutes = String(localDate.getMinutes()).padStart(2, '0');

      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    getStatusFromString(statusString) {
      const statusMap = {
        'Active': this.STATUS.PENDING,
        'pending': this.STATUS.PENDING,
        'accepted': this.STATUS.CONFIRMED,
        'inProcessed': this.STATUS.IN_PROGRESS,
        'completed': this.STATUS.DELIVERED,
        'rejected': this.STATUS.REJECTED,
        'canceled': this.STATUS.CANCELED
      };
      return statusMap[statusString] ?? this.STATUS.PENDING;
    },
  },
};
</script>

<style scoped>
.title-cadre {
  height: 40px;
  border-radius: 6px;
  background: var(--grays-gray-100, #F9FAFB);
}

.title {
  color: var(--accent-accent-black, #080C3E);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
}

.timelineStatus {
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 20px 0;
  width: 100%;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  /* Ensure enough space for rejected status */
}

.main-timeline {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.status-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rejection-branch {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.vertical-line {
  width: 2px;
  height: 40px;
  background-color: #F25C5C;
  margin-bottom: 10px;
}

.rejected-status {
  margin-top: 5px;
}

.dimmed {
  opacity: 0.5;
}

/* Ensure the main timeline stays visible */
.status-button {
  position: relative;
  z-index: 2;
}

/* Optional: Add transition for smooth status changes */
.rejection-branch {
  transition: all 0.3s ease;
}
</style>